import { render, staticRenderFns } from "./teamitem.vue?vue&type=template&id=29a3c8c6&scoped=true&"
import script from "./teamitem.vue?vue&type=script&lang=js&"
export * from "./teamitem.vue?vue&type=script&lang=js&"
import style0 from "./teamitem.vue?vue&type=style&index=0&id=29a3c8c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3c8c6",
  null
  
)

export default component.exports